module.exports = __webpack_public_path__ + "res/24-img_reward_t.3af47dfc471fdae72f87cd9d5dbb7d46.png";